import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'tfc-components';

import Icon from 'components/atoms/Icon';
import mapModifiers from 'utils/functions';

interface HeaderChatbotProps {
  title?: string;
  subTitle?: string;
  isBackButton?: boolean;
  isMinimize?: boolean;
  noHistory?: boolean;
  handleBack?: () => void;
  handleToggleMinimize?: () => void;
  handleHistory?: () => void;
  handleClose?: () => void;
  isExpand?: boolean;
  isImageBackground?: boolean;
}

// truncate function
export const truncateChars = (text = '', maxChars = 40) => {
  if (!text) return '';

  if (text.length <= maxChars) return text;

  return `${text.slice(0, maxChars)}…`;
};

const HeaderChatbot: React.FC<HeaderChatbotProps> = ({
  title,
  subTitle,
  isBackButton,
  isMinimize,
  noHistory,
  handleBack,
  handleToggleMinimize,
  handleHistory,
  handleClose,
  isExpand,
  isImageBackground,
}) => {
  const [isMobile, setIsMobile] = useState(isExpand);
  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage({ type: 'OPEN_IFRAME', open: false }, '*');
    setIsMobile(document.body.clientWidth < 480);
    const onResize = () => {
      if (document.body.clientWidth < 480) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  const renderExpandOrBackButton = () => (isBackButton ? (
    <Icon iconName="leftArrow" size={isBackButton ? '20x20' : '24'} />
  ) : (
    <Icon iconName={isMinimize ? 'expand' : 'expandOut'} size="20x20" />
  ));

  const renderCloseOrBackButton = () => (isBackButton ? (
    <Icon iconName="leftArrow" size={isBackButton ? '20x20' : '24'} />
  ) : (
    <Icon iconName="grayClose" size="20x20" />
  ));

  return (
    <div className={mapModifiers('o-headerChatbot', isImageBackground ? 'isImageBackground' : '')}>
      <div className="o-headerChatbot_wrapper">
        <div className="o-headerChatbot_left">
          {/* Desktop: back icon | minimize icon */}
          {!isMobile && handleToggleMinimize && (
            <div
              className={mapModifiers('o-headerChatbot_left_icon', 'expand')}
              onClick={() => {
                if (isBackButton && handleBack) {
                  handleBack();
                } else if (handleToggleMinimize) {
                  handleToggleMinimize();
                }
              }}
            >
              {renderExpandOrBackButton()}
            </div>
          )}

          {/* Mobile:  back icon | close icon */}
          {isMobile && handleToggleMinimize && (
            <div
              className={mapModifiers('o-headerChatbot_left_icon', 'close')}
              onClick={() => {
                if (isBackButton && handleBack) {
                  handleBack();
                } else if (handleClose) {
                  handleClose();
                }
              }}
            >
              {renderCloseOrBackButton()}
            </div>
          )}

        </div>

        <div className="o-headerChatbot_titleWrap">
          <Typography.Heading type="h5" extendClasses="o-headerChatbot_title" fontweight="600">
            {isBackButton ? t('chatbot.conversationHistory') : title || ''}
          </Typography.Heading>
          {subTitle !== '' && <Typography.Text extendClasses="o-headerChatbot_subTitle">{truncateChars(subTitle, 40) || ''}</Typography.Text>}
        </div>

        {!isBackButton && !noHistory && (
          <div className="o-headerChatbot_right" onClick={handleHistory}>
            <Icon iconName="clock" size="20x20" />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderChatbot;
